/**
 * Converts a given date string to a Date object in the local timezone.
 *
 * @param date - The date string to be converted of the form 'yyyy-MM-dd'
 * @returns A Date object representing the local midnight of the given date string, or undefined if no date string is provided.
 */
export const getDateInLocalTimezone = (date?: string) => {
  if (!date) {
    return;
  }
  return new Date(date + 'T00:00:00');
};

export type DateFormat =
  | 'YYYY/MM/DD'
  | 'YYYY-MM-DD'
  | 'MM/DD/YYYY'
  | 'MM-DD-YYYY'
  | 'DD/MM/YYYY'
  | 'DD-MM-YYYY'
  | 'DD MMM YYYY';
